import * as React from "react";
import { forwardRef } from "react";
const SvgZoomIn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m14.282 15.707-4.796-4.818a5.9 5.9 0 0 1-3.445 1.114 6.002 6.002 0 1 1 4.854-2.527l4.796 4.818a1 1 0 0 1-1.084 1.63 1 1 0 0 1-.322-.217zm-12.217-9.7A3.976 3.976 0 1 0 6.04 2.01a3.986 3.986 0 0 0-3.976 3.997m2.981 1.999v-1h-.994a1 1 0 1 1 0-1.998h.994v-1a.994.994 0 0 1 1.989 0v1h.994a1 1 0 0 1 0 1.998h-.995v1a.994.994 0 1 1-1.989 0z" }));
const ForwardRef = forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
